import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { memo } from 'react';
import { useDispatch } from 'react-redux';
import { Input } from '@che-ins-ui/input';
import { InputError } from '@/components/common/InputError';
import { PassengerField } from '@/models/forms/interface';
import { formsActions } from '@/models/forms';
import { setPassengerBirthday } from '@/models/forms/setPassengerBirthday';
import { inputLabels, inputNames, inputPlaceholders } from '../consts';
const field = PassengerField.birthday;
export const PassengerBirthdayInput = memo(({ _uuid, appearance, birthday, errorMessage, }) => {
    const dispatch = useDispatch();
    return (_jsxs("div", { children: [_jsx(Input, { value: birthday, onChange: (value) => dispatch(setPassengerBirthday({ _uuid, value })), name: inputNames.birthday, label: inputLabels.birthday, shouldFitContent: true, placeholder: inputPlaceholders.birthday, appearance: appearance, invalid: Boolean(errorMessage), onBlur: () => {
                    dispatch(formsActions.setPassengerFieldDirty({
                        field,
                        _uuid,
                    }));
                } }), _jsx(InputError, { error: errorMessage })] }));
});
